package org.ksdfv.thelema.shader.node

abstract class GLSLInlineBase(override var name: String = ""): ShaderData() {
    override var scope: Int
        get() = GLSLScope.Inline
        set(_) {}

    protected fun str(float: Float): String {
        val v = float.toString()
        return if (v.contains('.')) v else "$v.0"
    }
}
